import { Injectable, signal, WritableSignal } from '@angular/core';
import { I18nApiService } from '@app/api/services/i18n-api.service';
import { TranslationObject } from '@ngx-translate/core';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DefaultJsonFileLoader {
  private translation: WritableSignal<TranslationObject | null> = signal(null);

  constructor(private readonly i18nApiService: I18nApiService) {}

  public loadTranslate(): Observable<TranslationObject> {
    const translation = this.translation();

    if (translation) {
      return of(translation);
    }

    return this.preloadTranslate();
  }

  public preloadTranslate(): Observable<TranslationObject> {
    return this.i18nApiService.getDefaultLocalTranslate().pipe(
      catchError(() => of({})),
      tap(data => this.translation.set(data))
    );
  }

  public isTranslationLoaded(): boolean {
    return this.translation() !== null;
  }

  public getTranslation(): TranslationObject {
    const translation = this.translation();

    if (translation === null) return {};

    return translation;
  }
}
